import { Typography } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";

import type { LiveRowMark } from "./useLiveListSync";

const TICK_MS = 30_000;

export const LiveRowMarksContext = createContext<
  ReadonlyMap<string, LiveRowMark>
>(new Map());

const sinceLabel = (at: number) => {
  const minutes = Math.floor((Date.now() - at) / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  return `${Math.floor(minutes / 60)} h ago`;
};

export function LiveRowNote({ id }: { id: string }) {
  const mark = useContext(LiveRowMarksContext).get(id);
  const isMoved = mark?.kind === "moved";
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!isMoved) return;
    const timer = setInterval(() => setTick((t) => t + 1), TICK_MS);
    return () => clearInterval(timer);
  }, [isMoved]);

  if (mark?.kind !== "moved") return null;
  return (
    <Typography variant="caption" color="text.secondary" noWrap>
      by {mark.actorName ?? "someone"} · {sinceLabel(mark.at)}
    </Typography>
  );
}
